import { connect } from "react-redux";
import Header from "../../../Components/DashboardComponent/Header/Header";
const mapStateToProps = (state) => ({
   presencesProfile: state.reducer.presencesProfile,
  
});
const mapDispatchToProps = (dispatch) => ({
});
 
export default connect(mapStateToProps, mapDispatchToProps)(Header);